module.exports = "https://static.wmbcdn.com/uniweb/images/9ea9209222e70d0dca7fc1a1ea292756.svg";